import React from "react";
import { Button, Modal, Form } from "semantic-ui-react";

import { createSaveLink } from "./utils";

export function CustomListModal({
  name,
  setName,
  open,
  onClose,
  allSongs,
  selected,
}) {
  return (
    <Modal size="mini" onClose={() => onClose()} open={open}>
      <Modal.Header>Save Custom Playlist</Modal.Header>
      <Modal.Content>
        <Form.Input
          fluid
          label="Playlist name"
          placeholder="playlist name"
          onChange={(_ev, { value }) => setName(value)}
          value={name}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          content="Save"
          labelPosition="right"
          icon="checkmark"
          onClick={() => {
            const [, a] = createSaveLink(name, allSongs, selected);

            a.click();

            onClose();
          }}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
}
